'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var language = require('@gig/magic-sdk/dist/adapter/users/language');
var getCountries = require('@gig/magic-sdk/dist/adapter/users/getCountries');

(function(Language63912) {
  Language63912["ENGLISH"] = "en";
  Language63912["SWEDISH"] = "sw";
  Language63912["FINNISH"] = "fi";
  Language63912["GERMAN"] = "de";
  Language63912["NORWEGIAN"] = "no";
  Language63912["DUTCH"] = "nl";
  Language63912["TURKISH"] = "tr";
  Language63912["DANISH"] = "da";
  Language63912["LATVIAN"] = "lv";
  Language63912["RUSSIAN"] = "ru";
  Language63912["SPANISH"] = "es";
  Language63912["MACEDONIAN"] = "mk";
  Language63912["HUNGARIAN"] = "hu";
  Language63912["FRENCH"] = "fr";
  Language63912["JAPANESE"] = "ja";
  Language63912["HINDI"] = "hi";
  Language63912["THAI"] = "th";
  Language63912["ROMANIAN"] = "ro";
  Language63912["MANDARIN"] = "zh";
  Language63912["PORTUGUESE"] = "pt";
  Language63912["ESTONIAN"] = "et";
  Language63912["IRISH"] = "en";
})(exports.Language6391 || (exports.Language6391 = {}));
(function(Language63922) {
  Language63922["ENGLISH"] = "eng";
  Language63922["SWEDISH"] = "swe";
  Language63922["FINNISH"] = "fin";
  Language63922["GERMAN"] = "deu";
  Language63922["NORWEGIAN"] = "nor";
  Language63922["DUTCH"] = "nld";
  Language63922["TURKISH"] = "tur";
  Language63922["DANISH"] = "dan";
  Language63922["BRITISH"] = "eng";
  Language63922["AUSTRALIAN"] = "aus";
  Language63922["CANADIAN"] = "eng";
  Language63922["NEW_ZEALAND"] = "eng";
  Language63922["LATVIAN"] = "lav";
  Language63922["RUSSIAN"] = "rus";
  Language63922["SPANISH"] = "spa";
  Language63922["MACEDONIAN"] = "mkd";
  Language63922["HUNGARIAN"] = "hun";
  Language63922["CANADIAN_FRENCH"] = "fra";
  Language63922["JAPANESE"] = "jpn";
  Language63922["HINDI"] = "hin";
  Language63922["THAI"] = "tha";
  Language63922["ARGENTINE_SPANISH"] = "spa";
  Language63922["ROMANIAN"] = "ron";
  Language63922["SOUTH_AFRICAN"] = "zaf";
  Language63922["CHILEAN"] = "chl";
  Language63922["MANDARIN"] = "cmn";
  Language63922["PERU"] = "per";
  Language63922["BRAZILIAN_PORTUGUESE"] = "bpt";
  Language63922["ESTONIAN"] = "est";
  Language63922["IRISH"] = "eng";
})(exports.Language6392 || (exports.Language6392 = {}));
(function(UnicodeBCP47LocaleIdentifier2) {
  UnicodeBCP47LocaleIdentifier2["ENGLISH"] = "en";
  UnicodeBCP47LocaleIdentifier2["SWEDISH"] = "sv-SE";
  UnicodeBCP47LocaleIdentifier2["FINNISH"] = "fi-FI";
  UnicodeBCP47LocaleIdentifier2["GERMAN"] = "de-DE";
  UnicodeBCP47LocaleIdentifier2["NORWEGIAN"] = "no-NO";
  UnicodeBCP47LocaleIdentifier2["DUTCH"] = "nl-NL";
  UnicodeBCP47LocaleIdentifier2["TURKISH"] = "tr-TR";
  UnicodeBCP47LocaleIdentifier2["DANISH"] = "da-DK";
  UnicodeBCP47LocaleIdentifier2["BRITISH"] = "en-GB";
  UnicodeBCP47LocaleIdentifier2["AUSTRALIAN"] = "en-AU";
  UnicodeBCP47LocaleIdentifier2["CANADIAN"] = "en-CA";
  UnicodeBCP47LocaleIdentifier2["NEW_ZEALAND"] = "en-NZ";
  UnicodeBCP47LocaleIdentifier2["LATVIAN"] = "lv-LV";
  UnicodeBCP47LocaleIdentifier2["RUSSIAN"] = "ru-RU";
  UnicodeBCP47LocaleIdentifier2["SPANISH"] = "es-ES";
  UnicodeBCP47LocaleIdentifier2["MACEDONIAN"] = "mk-MK";
  UnicodeBCP47LocaleIdentifier2["HUNGARIAN"] = "hu-HU";
  UnicodeBCP47LocaleIdentifier2["CANADIAN_FRENCH"] = "fr-CA";
  UnicodeBCP47LocaleIdentifier2["JAPANESE"] = "ja-JP";
  UnicodeBCP47LocaleIdentifier2["HINDI"] = "hi-IN";
  UnicodeBCP47LocaleIdentifier2["THAI"] = "th-TH";
  UnicodeBCP47LocaleIdentifier2["ARGENTINE_SPANISH"] = "es-AR";
  UnicodeBCP47LocaleIdentifier2["ROMANIAN"] = "ro-RO";
  UnicodeBCP47LocaleIdentifier2["SOUTH_AFRICAN"] = "en-ZA";
  UnicodeBCP47LocaleIdentifier2["CHILEAN"] = "es-CL";
  UnicodeBCP47LocaleIdentifier2["MANDARIN"] = "zh-CN";
  UnicodeBCP47LocaleIdentifier2["PERU"] = "es-PE";
  UnicodeBCP47LocaleIdentifier2["BRAZILIAN_PORTUGUESE"] = "pt-BR";
  UnicodeBCP47LocaleIdentifier2["ESTONIAN"] = "et-EE";
  UnicodeBCP47LocaleIdentifier2["IRISH"] = "en-IE";
})(exports.UnicodeBCP47LocaleIdentifier || (exports.UnicodeBCP47LocaleIdentifier = {}));
const iso6392Map = {
  [language.Language.ENGLISH]: exports.Language6392.ENGLISH,
  [language.Language.SWEDISH]: exports.Language6392.SWEDISH,
  [language.Language.FINNISH]: exports.Language6392.FINNISH,
  [language.Language.GERMAN]: exports.Language6392.GERMAN,
  [language.Language.NORWEGIAN]: exports.Language6392.NORWEGIAN,
  [language.Language.DUTCH]: exports.Language6392.DUTCH,
  [language.Language.BRITISH]: exports.Language6392.BRITISH,
  [language.Language.TURKISH]: exports.Language6392.TURKISH,
  [language.Language.DANISH]: exports.Language6392.DANISH,
  [language.Language.AUSTRALIAN]: exports.Language6392.AUSTRALIAN,
  [language.Language.CANADIAN]: exports.Language6392.CANADIAN,
  [language.Language.NEW_ZEALAND]: exports.Language6392.NEW_ZEALAND,
  [language.Language.LATVIAN]: exports.Language6392.LATVIAN,
  [language.Language.RUSSIAN]: exports.Language6392.RUSSIAN,
  [language.Language.SPANISH]: exports.Language6392.SPANISH,
  [language.Language.MACEDONIAN]: exports.Language6392.MACEDONIAN,
  [language.Language.HUNGARIAN]: exports.Language6392.HUNGARIAN,
  [language.Language.CANADIAN_FRENCH]: exports.Language6392.CANADIAN_FRENCH,
  [language.Language.JAPANESE]: exports.Language6392.JAPANESE,
  [language.Language.HINDI]: exports.Language6392.HINDI,
  [language.Language.THAI]: exports.Language6392.THAI,
  [language.Language.ARGENTINE_SPANISH]: exports.Language6392.ARGENTINE_SPANISH,
  [language.Language.ROMANIAN]: exports.Language6392.ROMANIAN,
  [language.Language.SOUTH_AFRICAN]: exports.Language6392.SOUTH_AFRICAN,
  [language.Language.CHILEAN]: exports.Language6392.CHILEAN,
  [language.Language.MANDARIN]: exports.Language6392.MANDARIN,
  [language.Language.PERU]: exports.Language6392.PERU,
  [language.Language.BRAZILIAN_PORTUGUESE]: exports.Language6392.BRAZILIAN_PORTUGUESE,
  [language.Language.ESTONIAN]: exports.Language6392.ESTONIAN,
  [language.Language.IRISH]: exports.Language6392.IRISH
};
const countryLanguageMap = {
  [getCountries.Country.AUSTRIA]: language.Language.GERMAN,
  [getCountries.Country.GERMANY]: language.Language.GERMAN,
  [getCountries.Country.SWEDEN]: language.Language.SWEDISH,
  [getCountries.Country.NORWAY]: language.Language.NORWEGIAN,
  [getCountries.Country.FINLAND]: language.Language.FINNISH,
  [getCountries.Country.NEW_ZEALAND]: language.Language.NEW_ZEALAND,
  [getCountries.Country.DENMARK]: language.Language.DANISH,
  [getCountries.Country.UNITED_KINGDOM]: language.Language.BRITISH,
  [getCountries.Country.NETHERLANDS]: language.Language.DUTCH,
  [getCountries.Country.CANADA]: language.Language.CANADIAN,
  [getCountries.Country.LATVIA]: language.Language.LATVIAN,
  [getCountries.Country.RUSSIA]: language.Language.RUSSIAN,
  [getCountries.Country.MACEDONIA]: language.Language.MACEDONIAN,
  [getCountries.Country.SPAIN]: language.Language.SPANISH,
  [getCountries.Country.HUNGARY]: language.Language.HUNGARIAN,
  [getCountries.Country.JAPAN]: language.Language.JAPANESE,
  [getCountries.Country.INDIA]: language.Language.HINDI,
  [getCountries.Country.THAILAND]: language.Language.THAI,
  [getCountries.Country.ARGENTINA]: language.Language.ARGENTINE_SPANISH,
  [getCountries.Country.ROMANIA]: language.Language.ROMANIAN,
  [getCountries.Country.SOUTH_AFRICA]: language.Language.SOUTH_AFRICAN,
  [getCountries.Country.CHILE]: language.Language.CHILEAN,
  [getCountries.Country.SRI_LANKA]: language.Language.MANDARIN,
  [getCountries.Country.PERU]: language.Language.PERU,
  [getCountries.Country.BRAZIL]: language.Language.BRAZILIAN_PORTUGUESE,
  [getCountries.Country.ESTONIA]: language.Language.ESTONIAN,
  [getCountries.Country.IRELAND]: language.Language.IRISH
};
const iso6391Map = {
  [language.Language.ENGLISH]: exports.Language6391.ENGLISH,
  [language.Language.SWEDISH]: exports.Language6391.SWEDISH,
  [language.Language.FINNISH]: exports.Language6391.FINNISH,
  [language.Language.GERMAN]: exports.Language6391.GERMAN,
  [language.Language.NORWEGIAN]: exports.Language6391.NORWEGIAN,
  [language.Language.DUTCH]: exports.Language6391.DUTCH,
  [language.Language.BRITISH]: exports.Language6391.ENGLISH,
  [language.Language.TURKISH]: exports.Language6391.TURKISH,
  [language.Language.DANISH]: exports.Language6391.DANISH,
  [language.Language.AUSTRALIAN]: exports.Language6391.ENGLISH,
  [language.Language.CANADIAN]: exports.Language6391.ENGLISH,
  [language.Language.NEW_ZEALAND]: exports.Language6391.ENGLISH,
  [language.Language.LATVIAN]: exports.Language6391.LATVIAN,
  [language.Language.RUSSIAN]: exports.Language6391.RUSSIAN,
  [language.Language.SPANISH]: exports.Language6391.SPANISH,
  [language.Language.MACEDONIAN]: exports.Language6391.MACEDONIAN,
  [language.Language.HUNGARIAN]: exports.Language6391.HUNGARIAN,
  [language.Language.CANADIAN_FRENCH]: exports.Language6391.FRENCH,
  [language.Language.JAPANESE]: exports.Language6391.JAPANESE,
  [language.Language.HINDI]: exports.Language6391.HINDI,
  [language.Language.THAI]: exports.Language6391.THAI,
  [language.Language.ARGENTINE_SPANISH]: exports.Language6391.SPANISH,
  [language.Language.ROMANIAN]: exports.Language6391.ROMANIAN,
  [language.Language.SOUTH_AFRICAN]: exports.Language6391.ENGLISH,
  [language.Language.CHILEAN]: exports.Language6391.SPANISH,
  [language.Language.MANDARIN]: exports.Language6391.MANDARIN,
  [language.Language.PERU]: exports.Language6391.SPANISH,
  [language.Language.BRAZILIAN_PORTUGUESE]: exports.Language6391.PORTUGUESE,
  [language.Language.ESTONIAN]: exports.Language6391.ESTONIAN,
  [language.Language.IRISH]: exports.Language6391.IRISH
};
const languageTagBCP47 = {
  [language.Language.CANADIAN]: exports.UnicodeBCP47LocaleIdentifier.CANADIAN,
  [language.Language.CANADIAN_FRENCH]: exports.UnicodeBCP47LocaleIdentifier.CANADIAN_FRENCH,
  [language.Language.ENGLISH]: exports.UnicodeBCP47LocaleIdentifier.ENGLISH,
  [language.Language.SWEDISH]: exports.UnicodeBCP47LocaleIdentifier.SWEDISH,
  [language.Language.GERMAN]: exports.UnicodeBCP47LocaleIdentifier.GERMAN,
  [language.Language.NORWEGIAN]: exports.UnicodeBCP47LocaleIdentifier.NORWEGIAN,
  [language.Language.DUTCH]: exports.UnicodeBCP47LocaleIdentifier.DUTCH,
  [language.Language.TURKISH]: exports.UnicodeBCP47LocaleIdentifier.TURKISH,
  [language.Language.DANISH]: exports.UnicodeBCP47LocaleIdentifier.DANISH,
  [language.Language.BRITISH]: exports.UnicodeBCP47LocaleIdentifier.BRITISH,
  [language.Language.AUSTRALIAN]: exports.UnicodeBCP47LocaleIdentifier.AUSTRALIAN,
  [language.Language.NEW_ZEALAND]: exports.UnicodeBCP47LocaleIdentifier.NEW_ZEALAND,
  [language.Language.RUSSIAN]: exports.UnicodeBCP47LocaleIdentifier.RUSSIAN,
  [language.Language.LATVIAN]: exports.UnicodeBCP47LocaleIdentifier.LATVIAN,
  [language.Language.SPANISH]: exports.UnicodeBCP47LocaleIdentifier.SPANISH,
  [language.Language.MACEDONIAN]: exports.UnicodeBCP47LocaleIdentifier.MACEDONIAN,
  [language.Language.HUNGARIAN]: exports.UnicodeBCP47LocaleIdentifier.HUNGARIAN,
  [language.Language.JAPANESE]: exports.UnicodeBCP47LocaleIdentifier.JAPANESE,
  [language.Language.HINDI]: exports.UnicodeBCP47LocaleIdentifier.HINDI,
  [language.Language.FINNISH]: exports.UnicodeBCP47LocaleIdentifier.FINNISH,
  [language.Language.THAI]: exports.UnicodeBCP47LocaleIdentifier.THAI,
  [language.Language.ARGENTINE_SPANISH]: exports.UnicodeBCP47LocaleIdentifier.ARGENTINE_SPANISH,
  [language.Language.ROMANIAN]: exports.UnicodeBCP47LocaleIdentifier.ROMANIAN,
  [language.Language.SOUTH_AFRICAN]: exports.UnicodeBCP47LocaleIdentifier.SOUTH_AFRICAN,
  [language.Language.CHILEAN]: exports.UnicodeBCP47LocaleIdentifier.CHILEAN,
  [language.Language.MANDARIN]: exports.UnicodeBCP47LocaleIdentifier.MANDARIN,
  [language.Language.PERU]: exports.UnicodeBCP47LocaleIdentifier.PERU,
  [language.Language.BRAZILIAN_PORTUGUESE]: exports.UnicodeBCP47LocaleIdentifier.BRAZILIAN_PORTUGUESE,
  [language.Language.ESTONIAN]: exports.UnicodeBCP47LocaleIdentifier.ESTONIAN,
  [language.Language.IRISH]: exports.UnicodeBCP47LocaleIdentifier.IRISH
};
const getLanguageIso6391 = (language) => iso6391Map[language];
const getLanguageTagBCP47 = (language) => languageTagBCP47[language];
const getLocale = (language, country) => `${language.toLowerCase()}_${country.toUpperCase()}`;
const getLanguageIso6392 = (language) => iso6392Map[language];
const getLanguageForCountry = (country) => countryLanguageMap[country] || language.Language.ENGLISH;

exports.getLanguageForCountry = getLanguageForCountry;
exports.getLanguageIso6391 = getLanguageIso6391;
exports.getLanguageIso6392 = getLanguageIso6392;
exports.getLanguageTagBCP47 = getLanguageTagBCP47;
exports.getLocale = getLocale;
